export default "<p>info-business works!</p>\n"